import React, { useState, useContext, useEffect, useCallback } from "react";
import styles from "./index.module.scss";
// import Bounce from "react-reveal/Bounce";
import mainBg from "../../assets/images/mainBg.png";
import startBg from "../../assets/images/startBg.jpg";
import btnBg from "../../assets/images/btnBg.png";
import staticMobile from "../../assets/images/homeMobileStatic.png";
import staticDesktop from "../../assets/images/homeWebStatic.png";
import startButton from "../../assets/images/startButton.png";
import ventureBeyond from "../../assets/images/venturebeyond.png";

import MyMenu, { toggleMenu } from "./Menu";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ThreedScene, { allLinks } from "../ThreedScene/ThreedScene";
import { addGAWithUserInfo } from "../../App";
import { useScrollHandler } from "../../customHooks/useScroll";
import { NotificationPopup } from "../../components/popup";

export const Header = ({ handleBrandExperience }) => {
  let navigate = useNavigate();
  const { pathname } = useLocation()  
  
  const scrollValue = useScrollHandler(0);
  

  // console.log(scrollPosition);
  

  const handleClick = (eventName, url) => {
    addGAWithUserInfo(eventName, url);
    if (eventName === "buy_ticket") {
      window.open(url);
    } else {
      navigate(url, { replace: true });
      toggleMenu()
    }
  };

  return (
    <div style={{ backgroundColor: scrollValue >= 50 && (pathname === "/history" ||  pathname === "/notes" || pathname === "/taste"  || pathname === "/explore" || pathname === "/brand-experience" || pathname === "/detail" )? "#000" : "transparent"}} className={styles.navHeader}>
      <div>
        <div onClick={() => handleClick("Home", "/")}>
          <img
            src={require("../../assets/images/logo.png")}
            className={styles.logoWeb}
          />
        </div>
      </div>
      <div className={styles.navLinks}>
        {/* <div onClick={() => handleClick("Home", "/")}>
          <button className={styles.homeBtn}>Home</button>
        </div> */}
        <div
          onClick={() =>
            handleClick(
              "buy_ticket",
              "https://www.ticketmelon.com/event/Venturebeyondbypenfolds"
            )
          }
        >
          <button
            id="buyticket1"
            className={styles.authBtn}
            style={{
              backgroundImage: `url(${btnBg})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
            }}
          >
            Buy Ticket
          </button>
        </div>
        <MyMenu />
        <div id="menu" className={styles.dropdown}>
          <div
            onClick={() =>
              handleClick(
                "prepare_for_boarding",
                allLinks["/prepare-for-boarding"].route
              )
            }
            className={styles.menuLink}
          >
            PREPARE FOR BOARDING
          </div>
          <div
            onClick={() =>
              handleClick(
                "enter_space_shuttle",
                allLinks["/enter-space-shuttle"].route
              )
            }
            className={styles.menuLink}
          >
            ENTER THE SPACE SHUTTLE
          </div>
          <div
            onClick={() =>
              handleClick(
                "en_route_to_space",
                allLinks["/en-route-to-space"].route
              )
            }
            className={styles.menuLink}
          >
            EN-ROUTE TO SPACE
          </div>
          <div
            onClick={() =>
              handleClick(
                "the_lunar_experience",
                allLinks["/the-lunar-experience"].route
              )
            }
            className={styles.menuLink}
          >
            THE LUNAR EXPERIENCE
          </div>
          {/* <div
            onClick={() => handleClick("brand_experience", "/brand-experience")}
            className={styles.menuLink}
          >
           
             BRAND EXPERIENCE
          </div> */}
          
          <div
            onClick={() => handleClick("history", "/history")}
            className={styles.menuLink}
          >
            THE PENFOLDS STORY
          </div>
          <div
            onClick={() => handleClick("notes", "/notes")}
            className={styles.menuLink}
          >
            THE PENFOLDS TASTE
          </div>
          <div
            onClick={() => handleClick("taste_of_mirazur", "/taste")}
            className={styles.menuLink}
          >
            CURATED DINING EXPERIENCE
          </div>
          {/* <div
            onClick={() => handleClick("mission_complete", "/taste")}
            className={styles.menuLink}
          >
            MISSION COMPLETE
          </div> */}
          <div
            onClick={() => handleClick("explore_our_wines", "/explore?active_tab=venture_beyond")}
            className={styles.menuLink}
          >
            Explore our wines
          </div>
          <div
            onClick={() =>
              handleClick(
                "buy_ticket",
                "https://www.ticketmelon.com/event/Venturebeyondbypenfolds"
              )
            }
          >
            <button
              className={`${styles.authBtn} ${styles.butTicketBtn}`}
              style={{
                backgroundImage: `url(${btnBg})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
              }}
            >
              Buy Ticket
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

function HomeScene({ db }) {
  const [showstaticImg, setShowStaticImage] = useState(false);
  const [showPopUp, setShowPopUp] = useState(false)
  const { pathname } = useLocation()


  const videoStart = useCallback(() => {
  
      setShowPopUp(true)

  }, []);

  const backClick = useCallback(() => {
    // console.log("backClick");
  }, []);

  useEffect(() => {
    if (pathname === "/") {
      setShowStaticImage(true)
    }
  }, [pathname])

  useEffect(() => {
    window.parent.VideoStart = videoStart;

    window.parent.BackClick = backClick;
  }, [videoStart, backClick]);

  useEffect(() => {
    if (pathname === "/the-lunar-experience" && !showstaticImg) {
      setShowPopUp(true)
    }
    
    
    
  }, [pathname, showstaticImg])




  const handlePopUpClose = () => {
    setShowPopUp(false)
  }

  const handleStaticImg = (bool) => {
    if (pathname === "/") {
    setShowStaticImage(bool);
    }
  };

  let propsData = {
    isOpen: showPopUp,
    setClose: () => {},
    data: "ORDINARY DOESN'T BELONG TO THE MOON. YOUR BRAVERY DESERVES TO BE COMMEMORATED. REMEMBER THIS MOMENT WITH PHOTOS, VIDEOS, MEMOIRS THAT COULD INSPIRE FUTURE GENERATIONS.",
  };
  return (
    <div
      style={{
        backgroundImage: `url(${mainBg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        minHeight: "100vh",
        transition: "all ease .8s",
        overflow: "hidden",
      }}
      className={styles.homeWrapper}
    >
      {showPopUp && <div className={styles.popUp}>
      <NotificationPopup dataProps={propsData} handlePopUpClose={handlePopUpClose} />

        {/* <div></div>
        <div className={styles.text}>{`ORDINARY DOESN'T BELONG TO THE MOON. YOUR BRAVERY DESERVES TO BE COMMEMORATED. REMEMBER THIS MOMENT WITH PHOTOS, VIDEOS, MEMOIRS THAT COULD INSPIRE FUTURE GENERATIONS.`}</div> */}
        
        </div>}
      {showstaticImg && (
        <div className={`${styles.staticImage} ${styles.staticImageDesktop}`}>
          <img className={styles.stimg} src={staticDesktop} alt="" />
          <div className={`${styles.veyondText} ${styles.veyondTextWeb}`}>
            <img src={ventureBeyond} alt="" height="100%" width="100%" />
          </div>
          <img
            onClick={() => handleStaticImg(false)}
            className={styles.btimg}
            src={startButton}
            alt=""
          />
        </div>
      )}

      {showstaticImg && (
        <div className={`${styles.staticImage} ${styles.staticImageMobile}`}>
          <img className={styles.stimg} src={staticMobile} alt="" />
          <div className={styles.veyondText}>
            <img src={ventureBeyond} alt="" height="100%" width="100%" />
          </div>
          <img
            onClick={() => handleStaticImg(false)}
            className={styles.btimg}
            src={startButton}
            alt=""
          />
        </div>
      )}
      <Header />
      <ThreedScene db={db} />
    </div>
  );
}

export default HomeScene;
